import React from 'react';

import AdminPanelSettingsOutlinedIcon from '@mui/icons-material/AdminPanelSettingsOutlined';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import { Chip, Tooltip } from '@mui/material';

import usePromoAdminPermission from './hooks/usePromoPermission';

type Props = {
  /** Explains the specific action which is restricted to promo admins. */
  action?: string;
};

/** Compact, header-safe status for actions that require the promo-admin role. */
export default function PromoAdminRequiredIndicator({ action = 'This action' }: Props) {
  const isPromoAdmin = usePromoAdminPermission();
  const status = isPromoAdmin ? 'You have the promo-admin role.' : 'You do not have the promo-admin role.';

  return (
    <Tooltip title={`${action} requires the promo-admin role. ${status}`}>
      <Chip
        color={isPromoAdmin ? 'success' : 'warning'}
        icon={isPromoAdmin ? <CheckCircleOutlineIcon /> : <AdminPanelSettingsOutlinedIcon />}
        label="Promo admin required"
        size="small"
        variant="outlined"
        aria-label={`${action} requires promo-admin permission. ${status}`}
      />
    </Tooltip>
  );
}
